<svelte:head>
  <meta name="application-name" content="{$_('title')}" />
  <meta name="msapplication-TileColor" content="#fff" />
  {#each [57, 60, 72, 76, 114, 120, 144, 152] as size}
    <link rel="apple-touch-icon" sizes="{size}x{size}" href="images/apple-touch-icon-{size}x{size}.png" />
  {/each}
  {#each [16, 32, 96, 128, 196] as size}
    <link rel="icon" type="image/png" href="images/favicon-{size}x{size}.png" sizes="{size}x{size}" />
  {/each}
  {#each [70, 144, 150, 310] as size}
    <meta name="msapplication-TileImage" content="images/mstile-{size}x{size}.png" />
  {/each}
  <meta name="msapplication-wide310x150logo" content="images/mstile-310x150.png" />
  <meta property="og:site_name" content="{$_('title')}">
  <meta property="og:locale" content="{$locale}_{$locale.toUpperCase()}">
  <meta name="twitter:card" content="summary_large_image">
  <meta name="google-site-verification" content="dEYiENJ00eQ-55HrHFZTZBpxhljJcgwmmj4jd0WVrgA" />
  <link rel="preload" as="font" crossorigin="crossorigin" href="fonts/LabGrotesque-Regular.woff2">
  <link rel="preload" as="font" crossorigin="crossorigin" href="fonts/LabGrotesque-Bold.woff2">
  <link rel="preconnect" href="https://js.stripe.com/v3">
  <link rel="preconnect" href="https://www.gstatic.com">
  <link rel="preconnect" href="https://www.googletagmanager.com">
  <script data-config={rollbarConfig} data-host={$page.host}>
    (function() {
      var dataset = document.currentScript.dataset;
      var config = JSON.parse(dataset.config);
      if (config.environment === 'development') return;
      window._rollbarConfig = {
        accessToken: 'a15ee8102f3c4e43b1e8d0ae95cf1356',
        captureUncaught: true,
        captureUnhandledRejections: true,
        ignoredMessages: [
          'Script error',
          "undefined is not an object (evaluating 'n.x')",
          "Cannot read property 'toUpperCase' of undefined",
          "Can't find variable: fetch",
          "Failed to register a ServiceWorker"
        ],
        hostWhiteList: ['https://' + dataset.host],
        payload: config
      };
      !function(r){function e(n){if(o[n])return o[n].exports;var t=o[n]={exports:{},id:n,loaded:!1};return r[n].call(t.exports,t,t.exports,e),t.loaded=!0,t.exports}var o={};return e.m=r,e.c=o,e.p="",e(0)}([function(r,e,o){"use strict";var n=o(1),t=o(4);_rollbarConfig=_rollbarConfig||{},_rollbarConfig.rollbarJsUrl=_rollbarConfig.rollbarJsUrl||"https://cdnjs.cloudflare.com/ajax/libs/rollbar.js/2.19.4/rollbar.min.js",_rollbarConfig.async=void 0===_rollbarConfig.async||_rollbarConfig.async;var a=n.setupShim(window,_rollbarConfig),l=t(_rollbarConfig);window.rollbar=n.Rollbar,a.loadFull(window,document,!_rollbarConfig.async,_rollbarConfig,l)},function(r,e,o){"use strict";function n(r){return function(){try{return r.apply(this,arguments)}catch(r){try{console.error("[Rollbar]: Internal error",r)}catch(r){}}}}function t(r,e){this.options=r,this._rollbarOldOnError=null;var o=s++;this.shimId=function(){return o},"undefined"!=typeof window&&window._rollbarShims&&(window._rollbarShims[o]={handler:e,messages:[]})}function a(r,e){if(r){var o=e.globalAlias||"Rollbar";if("object"==typeof r[o])return r[o];r._rollbarShims={},r._rollbarWrappedError=null;var t=new p(e);return n(function(){e.captureUncaught&&(t._rollbarOldOnError=r.onerror,i.captureUncaughtExceptions(r,t,!0),i.wrapGlobals(r,t,!0)),e.captureUnhandledRejections&&i.captureUnhandledRejections(r,t,!0);var n=e.autoInstrument;return e.enabled!==!1&&(void 0===n||n===!0||"object"==typeof n&&n.network)&&r.addEventListener&&(r.addEventListener("load",t.captureLoad.bind(t)),r.addEventListener("DOMContentLoaded",t.captureDomContentLoaded.bind(t))),r[o]=t,t})()}}function l(r){return n(function(){var e=this,o=Array.prototype.slice.call(arguments,0),n={shim:e,method:r,args:o,ts:new Date};window._rollbarShims[this.shimId()].messages.push(n)})}var i=o(2),s=0,d=o(3),c=function(r,e){return new t(r,e)},p=d.bind(null,c);t.prototype.loadFull=function(r,e,o,t,a){var l=function(){var e;if(void 0===r._rollbarDidLoad){e=new Error("rollbar.js did not load");for(var o,n,t,l,i=0;o=r._rollbarShims[i++];)for(o=o.messages||[];n=o.shift();)for(t=n.args||[],i=0;i<t.length;++i)if(l=t[i],"function"==typeof l){l(e);break}}"function"==typeof a&&a(e)},i=!1,s=e.createElement("script"),d=e.getElementsByTagName("script")[0],c=d.parentNode;s.crossOrigin="",s.src=t.rollbarJsUrl,o||(s.async=!0),s.onload=s.onreadystatechange=n(function(){if(!(i||this.readyState&&"loaded"!==this.readyState&&"complete"!==this.readyState)){s.onload=s.onreadystatechange=null;try{c.removeChild(s)}catch(r){}i=!0,l()}}),c.insertBefore(s,d)},t.prototype.wrap=function(r,e,o){try{var n;if(n="function"==typeof e?e:function(){return e||{}},"function"!=typeof r)return r;if(r._isWrap)return r;if(!r._rollbar_wrapped&&(r._rollbar_wrapped=function(){o&&"function"==typeof o&&o.apply(this,arguments);try{return r.apply(this,arguments)}catch(o){var e=o;throw e&&("string"==typeof e&&(e=new String(e)),e._rollbarContext=n()||{},e._rollbarContext._wrappedSource=r.toString(),window._rollbarWrappedError=e),e}},r._rollbar_wrapped._isWrap=!0,r.hasOwnProperty))for(var t in r)r.hasOwnProperty(t)&&(r._rollbar_wrapped[t]=r[t]);return r._rollbar_wrapped}catch(e){return r}};for(var u="log,debug,info,warn,warning,error,critical,global,configure,handleUncaughtException,handleUnhandledRejection,captureEvent,captureDomContentLoaded,captureLoad".split(","),f=0;f<u.length;++f)t.prototype[u[f]]=l(u[f]);r.exports={setupShim:a,Rollbar:p}},function(r,e){"use strict";function o(r,e,o){if(r){var t;"function"==typeof e._rollbarOldOnError?t=e._rollbarOldOnError:r.onerror&&!r.onerror.belongsToShim&&(t=r.onerror,e._rollbarOldOnError=t);var a=function(){var o=Array.prototype.slice.call(arguments,0);n(r,e,t,o)};a.belongsToShim=o,r.onerror=a}}function n(r,e,o,n){r._rollbarWrappedError&&(n[4]||(n[4]=r._rollbarWrappedError),n[5]||(n[5]=r._rollbarWrappedError._rollbarContext),r._rollbarWrappedError=null),e.handleUncaughtException.apply(e,n),o&&o.apply(r,n)}function t(r,e,o){if(r){"function"==typeof r._rollbarURH&&r._rollbarURH.belongsToShim&&r.removeEventListener("unhandledrejection",r._rollbarURH);var n=function(r){var o,n,t;try{o=r.reason}catch(r){o=void 0}try{n=r.promise}catch(r){n="[unhandledrejection] error getting `promise` from event"}try{t=r.detail,!o&&t&&(o=t.reason,n=t.promise)}catch(r){t="[unhandledrejection] error getting `detail` from event"}o||(o="[unhandledrejection] error getting `reason` from event"),e&&e.handleUnhandledRejection&&e.handleUnhandledRejection(o,n)};n.belongsToShim=o,r._rollbarURH=n,r.addEventListener("unhandledrejection",n)}}function a(r,e,o){if(r){var n,t,a="EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");for(n=0;n<a.length;++n)t=a[n],r[t]&&r[t].prototype&&l(e,r[t].prototype,o)}}function l(r,e,o){if(e.hasOwnProperty&&e.hasOwnProperty("addEventListener")){for(var n=e.addEventListener;n._rollbarOldAdd&&n.belongsToShim;)n=n._rollbarOldAdd;var t=function(e,o,t){n.call(this,e,r.wrap(o),t)};t._rollbarOldAdd=n,t.belongsToShim=o,e.addEventListener=t;for(var a=e.removeEventListener;a._rollbarOldRemove&&a.belongsToShim;)a=a._rollbarOldRemove;var l=function(r,e,o){a.call(this,r,e&&e._rollbar_wrapped||e,o)};l._rollbarOldRemove=a,l.belongsToShim=o,e.removeEventListener=l}}r.exports={captureUncaughtExceptions:o,captureUnhandledRejections:t,wrapGlobals:a}},function(r,e){"use strict";function o(r,e){this.impl=r(e,this),this.options=e,n(o.prototype)}function n(r){for(var e=function(r){return function(){var e=Array.prototype.slice.call(arguments,0);if(this.impl[r])return this.impl[r].apply(this.impl,e)}},o="log,debug,info,warn,warning,error,critical,global,configure,handleUncaughtException,handleUnhandledRejection,_createItem,wrap,loadFull,shimId,captureEvent,captureDomContentLoaded,captureLoad".split(","),n=0;n<o.length;n++)r[o[n]]=e(o[n])}o.prototype._swapAndProcessMessages=function(r,e){this.impl=r(this.options);for(var o,n,t;o=e.shift();)n=o.method,t=o.args,this[n]&&"function"==typeof this[n]&&("captureDomContentLoaded"===n||"captureLoad"===n?this[n].apply(this,[t[0],o.ts]):this[n].apply(this,t));return this},r.exports=o},function(r,e){"use strict";r.exports=function(r){return function(e){if(!e&&!window._rollbarInitialized){r=r||{};for(var o,n,t=r.globalAlias||"Rollbar",a=window.rollbar,l=function(r){return new a(r)},i=0;o=window._rollbarShims[i++];)n||(n=o.handler),o.handler._swapAndProcessMessages(l,o.messages);window[t]=n,window._rollbarInitialized=!0}}}}]);
    })();
  </script>
</svelte:head>

<svelte:window on:message={handleMessage} />

{#if !isSpecialPage(segment)}
  <Header path={$page.path} />
{/if}

<main class:fullscreen={fullscreenLayout(segment)}>
  <slot />
  {#if !isSpecialPage(segment)}
    <CookieMessage />
  {/if}
</main>

{#if !isSpecialPage(segment)}
  <Footer />
{/if}

{#if $popup}
  <Popup
    hidden={false}
    isMobile={!!$session.mobilePlatform}
    {...$popup.popupProps}
  >
    <svelte:component this={$popup.component} {...$popup.props} />
  </Popup>
{/if}

{#if $alert}
  <Alert {...$alert} />
{/if}

<style lang="stylus">
  @font-face
    font-family: LabGrotesque
    font-weight: normal
    font-display: swap
    src: url('fonts/LabGrotesque-Regular.woff2') format('woff2'),
      url('fonts/LabGrotesque-Regular.woff') format('woff')

  @font-face
    font-family: LabGrotesque
    font-weight: 500
    font-display: swap
    src: url('fonts/LabGrotesque-Medium.woff2') format('woff2'),
      url('fonts/LabGrotesque-Medium.woff') format('woff')

  @font-face
    font-family: LabGrotesque
    font-weight: bold
    font-display: swap
    src: url('fonts/LabGrotesque-Bold.woff2') format('woff2'),
      url('fonts/LabGrotesque-Bold.woff') format('woff')

  :global(html, body, #app-container)
    height: 100%
    margin: 0
    padding: 0

  :global(body)
    font: 1em/1.5 $font-lab-grotesque
    color: $color
    background: $bg-color

  :global(#app-container)
    display: flex
    flex-direction: column

  :global(a)
    color: $violet

    @media $bp.desktop
      &:hover
        text-decoration: none

  main
    margin: 0 24px
    flex-grow: 1

    @media $bp.desktop
      width: $main-width
      margin: auto

  main.fullscreen
    margin 0
    @media $bp.desktop
      width: 100%
</style>

<script context="module">
  import { locale, translations } from 'svelte-intl';
  import getConfig from '../getConfig';

  function setDefaultTranslations(messages, localeKey) {
    translations.update({
      [localeKey]: messages
    });
    locale.set(localeKey);
  }

  export async function preload(page, session) {
    const config = getConfig(session.env);
    const fetchers = [
      this.fetch(`/locales/${session.lang}.json`)
        .then((res) => res.json()),
    ];

    if (session.user) {
      fetchers.push(this.fetch('/api/account', {
        credentials: 'include'
      }).then((res) => res.json()));
    }

    const [messages, accountData] = await Promise.all(fetchers);

    setDefaultTranslations(messages, session.lang);

    if (!accountData) return { messages, config };

    if (!accountData.user) {
      session.user = null;
      user.set(null);
    } else {
      user.set({
        ...accountData.user,
        csrfToken: session.csrfToken
      });
    }

    return { messages, account: accountData.user, config };
  }
</script>

<script>
  import { onMount } from 'svelte';
  import { stores } from '@sapper/app';
  import { _ } from 'svelte-intl';
  import {
    alert,
    packs,
    popup,
    user,
    config as configStore
  } from '../stores';

  import Header from '../components/Header.svelte';
  import Footer from '../components/Footer.svelte';
  import Alert from '../components/Alert.svelte';
  import Popup from '../components/Popup.svelte';
  import CookieMessage from '../components/CookieMessage.svelte';

  export let segment;
  export let messages;
  export let config;
  export let account = null;

  const { page, session } = stores();

  configStore.set(config);

  const isSpecialPage = (segment) => (
    segment === 'specials' || $page.query.from_app
  );

  const fullscreenLayout = (segment) => (
    segment === 'todays'
  );

  const handleMessage = ({ data }) => {
    if (data.type === 'auth-success') {
      location.reload();
    }
  };

  $: rollbarConfig = JSON.stringify({
    environment: $session.env,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: process.env.GIT_SHA
      }
    },
    person: $session.user ? {
      id: $session.user.user_id,
      email: $session.user.email
    } : null
  });

  setDefaultTranslations(messages, $session.lang);

  onMount(async () => {
    if ($session.user) {
      user.set({
        ...account,
        csrfToken: $session.csrfToken
      });
      await packs.load();
    }

    const { firebase, firebaseui } = window;
    if (!firebase || !firebase.auth) return;

    if (!firebase.apps.length) {
      firebase.initializeApp({
        ...$session.firebase,
        projectId: config.FIREBASE_PROJECT_ID,
        appId: config.FIREBASE_APP_ID,
        measurementId: config.FIREBASE_MEASUREMENT_ID
      });

      firebase.auth().languageCode = $locale;
      firebase.analytics();
    }

    if ($session.user) {
      firebase.analytics().setUserId($session.user.user_id);
    }

    const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
    if (ui.isPendingRedirect() || firebase.auth().isSignInWithEmailLink(location.href)) {
      user.logIn();
    }
  });
</script>
